export default function BirdIcon() {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 24 24"
      width="24"
      height="24"
      fill="none"
      stroke="currentColor"
      strokeWidth="1.6"
      strokeLinecap="round"
      strokeLinejoin="round"
      aria-hidden="true"
    >
      <circle cx="15" cy="8" r="3" />
      <path d="M17.8 7.2 20.6 8l-2.8.9" />
      <path d="M12.6 9.6C8.4 9.8 5.2 12.6 5 16.2L3 18.5h5.4c4.2 0 7.4-3 7.4-7.3" />
      <path d="M8.2 14.6c2.1.1 4-.9 5.1-2.6" />
      <path d="M10 18.5v2.2M12.6 18v2.7" />
      <circle fill="currentColor" stroke="none" cx="15.6" cy="7.6" r=".8" />
    </svg>
  );
}
